import React from 'react';

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { Container, Button, Row, Col, Form, Spinner } from 'react-bootstrap';
import MaterialTable from 'material-table';
import { dateFormatUtil } from '../Utilities';
import Modal from 'react-bootstrap/Modal';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';

class EditMapping extends React.Component {
    _isMounted = false;
    state = {
        alert: 0,
        alertMessage: '',
        flag: false,
        showAddEdit: true,
        selectedRow: this.props.selectedRow
            ? this.props.selectedRow.AadharNumber
            : false,
        Distributors: [],
        StoreOwners: [],
        Employees: [],
        StoreCPs: [],

        SelectedDistributor: this.props.selectedRow
            ? this.props.selectedRow.Distributor
            : '',
        SelectedStoreOwner: this.props.selectedRow
            ? this.props.selectedRow.StoreOwner
            : '',
        SelectedEmployee: this.props.selectedRow
            ? this.props.selectedRow.Employee
            : '',
        SelectedStoreCP: this.props.selectedRow
            ? this.props.selectedRow.StoreCP
            : '',

        SelectedDistributorView: this.props.selectedRow
            ? this.props.selectedRow.DistributorNameView
            : '',
        SelectedStoreOwnerView: this.props.selectedRow
            ? this.props.selectedRow.StoreOwnerNameView
            : '',
        SelectedEmployeeView: this.props.selectedRow
            ? this.props.selectedRow.EmployeeNameView
            : '',
        SelectedStoreCPView: this.props.selectedRow
            ? this.props.selectedRow.StoreCPNameView
            : '',

        StoreTag: this.props.selectedRow ? this.props.selectedRow.StoreTag : '',

        LastUpdatedTimeStamp: '',
        UpdatedBy: '',
        RequestedTimeStamp: ''
    };

    componentWillUnmount() {
        this._isMounted = false;
    }
    async componentDidMount() {
        
        this._isMounted = true;
        this.loadData();
    }
    async loadData() {
        if (this._isMounted) {
            this.setState({ flag: true });
        }

        this.getAllApprovedUsers('Distributors');
        this.getAllApprovedUsers('StoreOwners');
        this.getAllApprovedUsers('Employees');
        this.getAllApprovedUsers('StoreCP');
    }

    async getAllApprovedUsers(collectionName) {
        let res = [];

        await RestServices.getAllApprovedProfiles(
            localStorage.getItem('FirebaseToken'),
            collectionName
        )
            .then((response) => response.json())
            .then((ProifleList) => {
                if (ProifleList.error) {
                    if (this._isMounted) {
                        this.setState({
                            alert: 1,
                            alertMessage: ProifleList.error
                        });
                    }
                } else {
                    if (collectionName == 'Distributors') {
                        if (this._isMounted) {
                            this.setState({ Distributors: ProifleList });
                        }
                    }
                    if (collectionName == 'StoreOwners') {
                        if (this._isMounted) {
                            this.setState({ StoreOwners: ProifleList });
                        }
                    }
                    if (collectionName == 'Employees') {
                        if (this._isMounted) {
                            this.setState({ Employees: ProifleList });
                        }
                    }
                    if (collectionName == 'StoreCP') {
                        if (this._isMounted) {
                            this.setState({ StoreCPs: ProifleList });
                        }
                    }

                    if (this._isMounted) {
                        this.setState({ flag: false });
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({ alert: 1, alertMessage: err.message });
                }
            });
    }

    onChangeValues = (event) => {
        if (event.target.value === '')
            this.setState({ [event.target.name]: '' });
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };

    SubmitFormData = () => {
        let data = {
            StoreTagDetail: this.props.selectedRow,
            SelectedDistributor: this.state.SelectedDistributor,
            SelectedStoreOwner: this.state.SelectedStoreOwner,
            SelectedEmployee: this.state.SelectedEmployee,
            SelectedStoreCP: this.state.SelectedStoreCP,

            RequestedTimeStamp: this.state.RequestedTimeStamp
                ? this.state.RequestedTimeStamp
                : dateFormatUtil(),
            LastUpdatedTimeStamp: dateFormatUtil(),
            UpdatedBy: this.props.user.FullName
        };

        

        this.setState({ flag: true, alert: 0, alertMessage: '' });

        RestServices.updateStoreTagMapping(
            localStorage.getItem('FirebaseToken'),
            data
        )
            .then((response) => response.json())
            .then((responseData) => {
                
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            flag: false,
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    if (responseData.status) {
                        if (this._isMounted) {
                            this.setState({
                                flag: false,
                                alert: 2,
                                alertMessage: 'Store Tag information updated...'
                            });
                        }
                    } else {
                        if (this._isMounted) {
                            this.setState({
                                flag: false,
                                alert: 1,
                                alertMessage: responseData.message
                            });
                        }
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        flag: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    };

    render() {
        return (
            <Container className="no_padding">
                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.alert === 2 && (
                    <Alert variant="success">{this.state.alertMessage}</Alert>
                )}

                {this.state.flag && <Spinner animation="border" />}

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Distributor</Form.Label>
                        <Autocomplete
                            name="SelectedDistributor"
                            value={this.state.SelectedDistributorView}
                            onChange={(event, newValue) => {
                                if (newValue) {
                                    this.setState({
                                        SelectedDistributorView: newValue
                                    });

                                    var Distributor = newValue.substring(
                                        newValue.indexOf('(') + 1,
                                        newValue.lastIndexOf(')')
                                    );
                                    this.setState({
                                        SelectedDistributor: Distributor
                                    });
                                } else {
                                    this.setState({
                                        SelectedDistributor: null,
                                        SelectedDistributorView: ''
                                    });
                                }
                            }}
                            options={this.state.Distributors.map((arr) => arr)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    margin="dense"
                                    variant="outlined"
                                />
                            )}
                        />{' '}
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Store Owner</Form.Label>

                        <Autocomplete
                            name="SelectedStoreOwners"
                            value={this.state.SelectedStoreOwnerView}
                            onChange={(event, newValue) => {
                                if (newValue) {
                                    this.setState({
                                        SelectedStoreOwnerView: newValue
                                    });
                                    var StoreOwner = newValue.substring(
                                        newValue.indexOf('(') + 1,
                                        newValue.lastIndexOf(')')
                                    );

                                    this.setState({
                                        SelectedStoreOwner: StoreOwner
                                    });
                                } else {
                                    this.setState({
                                        SelectedStoreOwner: null,
                                        SelectedStoreOwnerView: ''
                                    });
                                }
                            }}
                            options={this.state.StoreOwners}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    margin="dense"
                                    variant="outlined"
                                />
                            )}
                        />
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Employee</Form.Label>

                        <Autocomplete
                            name="SelectedEmployees"
                            value={this.state.SelectedEmployeeView}
                            onChange={(event, newValue) => {
                                if (newValue) {
                                    this.setState({
                                        SelectedEmployeeView: newValue
                                    });
                                    var Employee = newValue.substring(
                                        newValue.indexOf('(') + 1,
                                        newValue.lastIndexOf(')')
                                    );

                                    this.setState({
                                        SelectedEmployee: Employee
                                    });
                                } else {
                                    this.setState({
                                        SelectedEmployee: null,
                                        SelectedEmployeeView: ''
                                    });
                                }
                            }}
                            options={this.state.Employees.map((arr) => arr)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    margin="dense"
                                    variant="outlined"
                                />
                            )}
                        />
                    </Form.Group>
                </Form.Row>

                <Form.Row>
                    <Form.Group as={Col}>
                        <Form.Label>Channel Partner</Form.Label>
                        <Autocomplete
                            name="SelectedStoreCP"
                            value={this.state.SelectedStoreCPView}
                            onChange={(event, newValue) => {
                                if (newValue) {
                                    this.setState({
                                        SelectedStoreCPView: newValue
                                    });

                                    var StoreCP = newValue.substring(
                                        newValue.indexOf('(') + 1,
                                        newValue.lastIndexOf(')')
                                    );
                                    this.setState({ SelectedStoreCP: StoreCP });
                                } else {
                                    this.setState({
                                        SelectedStoreCP: null,
                                        SelectedStoreCPView: ''
                                    });
                                }
                            }}
                            options={this.state.StoreCPs.map((arr) => arr)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    margin="dense"
                                    variant="outlined"
                                />
                            )}
                        />{' '}
                    </Form.Group>
                </Form.Row>
                <hr />

                <Form.Row>
                    <Button
                        variant="primary"
                        type="submit"
                        onClick={this.SubmitFormData}
                    >
                        Submit
                    </Button>
                </Form.Row>
            </Container>
        );
    }
}

export default EditMapping;
